import React, { useState, useEffect } from 'react'
import { Container, Row, Col, ProgressBar } from 'react-bootstrap'

const LoadingScreen = () => {
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress >= 100) {
          clearInterval(timer)
          return 100
        }
        return prevProgress + 10
      })
    }, 800)

    return () => {
      clearInterval(timer)
    }
  }, [])

  return (
    <div className="loading-overlay">
      <Container>
        <Row className="min-vh-100 align-items-center justify-content-center">
          <Col xs={12} md={8} lg={6} className="text-center">
            <div className="loading-content p-4 rounded-3 shadow-sm">
              <div className="mb-4">
                <div className="spinner-border text-primary" style={{ width: '3.5rem', height: '3.5rem', borderWidth: '0.25em' }} role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>

              <h4 className="text-primary fw-bold mb-3">Initializing</h4>
              <p className="text-muted mb-4">Please wait while we load the application...</p>

              <div className="px-4">
                <ProgressBar animated striped now={progress} className="custom-progress" />
                <small className="text-muted mt-2 d-block">Loading... {progress}%</small>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      <style>
        {`
          .loading-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
            z-index: 9999;
          }
          .loading-content {
            background-color: rgba(255, 255, 255, 0.95);
            backdrop-filter: blur(10px);
            border: 1px solid rgba(0,0,0,0.1);
          }
          .custom-progress {
            height: 8px;
            background-color: #e9ecef;
            border-radius: 10px;
            overflow: hidden;
            box-shadow: inset 0 1px 2px rgba(0,0,0,0.1);
          }
          .progress-bar {
            background-color: #00c853;
            transition: width 0.3s ease;
          }
          .spinner-border {
            box-shadow: 0 0 15px rgba(13, 110, 253, 0.2);
          }
          @keyframes gradient {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }
        `}
      </style>
    </div>
  )
}

export default LoadingScreen
